<template>
  <div id="app">
    <keep-alive >
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
    <custom-toast ref="globalToast" />
  </div>
</template>

<script>
import CustomToast from '@/components/CustomToast.vue'

export default {
  components: {
    CustomToast
  },
  mounted() {
    // 将 toast 实例挂到 Vue 原型上，全局可用
    this.$root.$customToast = this.$refs.globalToast
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'PingFang SC','SourceHanSansCN',Helvetica-Light, microsoft YaHei,arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: rgba(0, 0, 0, 0.8);
  font-size: 0.28rem;
  max-width: 8rem;
  margin:0 auto;
  padding-bottom: 10rem;
}
.bold {
    font-weight: bold;
}
.text-center {
    text-align: center;
}

.footer div:first-of-type {
  max-width: 8rem;
}
</style>
